var PscPathRetrievalFactory = function ($resource, $window) {
  return {
    pscRetrievalPath: $resource(
      __baseApiUrl__ + "/participant-web-services/rest/nonauth/getPSCPath",
      {},
      {
        query: {
          method: "GET",
          isArray: true
        },
      }
    ),
  };
};

PscPathRetrievalFactory.$inject = ["$resource", "$window"];
export default PscPathRetrievalFactory;
